/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ModalHelpCtrl', function($scope, $location, $uibModalInstance, location, identity, Ticket) {
    $scope.location = location;
    $scope.me       = identity;

    $scope.cancel = () => $uibModalInstance.dismiss('cancel');

    return $scope.sendTicket = function() {
        $('#sendticket_Button_help').button('loading');
        $scope.error = undefined;

        const ticket = new Ticket({
            title:   `[${$scope.me.login}] J'ai besoin d'aide`,
            tags:    ['prepetna', 'help', 'asset'],
            message: `Je suis au :  \r\n ### ${$scope.location}\r\n`
        });

        return ticket
        .$save()
        .then(function() {
            $uibModalInstance.dismiss('done');
            return $location.path('/tickets');}).catch(() => $scope.error = 'Une erreur est survenue veuillez réessayer ultérieurement.');
    };
});
